import * as React  from "react";
import { useState, useEffect, useRef } from "react";
import axios from 'axios';

interface MessageHistory {
  message_histories: {
    id: string;
    message: string;
    m_patient_name: string;
    m_user_name: string;
    m_institution_name: string;
    byte_size: number;
    phone_number: string;
    converted_message_send_at: string;
    consumed_ticket_count: number;
  }[],
  history_total_count: number;
}

const PER = 10;
const SEND_KBN = { SMS: 0, LINE: 1 }

const History = () => {
  const [MessageHistories, setMessageHistories] = useState([]);
  const [marker, setMarker] = useState(PER);
  const [limit, setLimit] = useState(PER);
  const [patientword, setPatientword] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [isFetchedHistories, setIsFetchedHistories] = useState(false);
  const [hitoryTotalCount, setHistoryTotalCount] = useState(0);
  const messageSendAtFromRef = useRef(null);
  const messageSendAtToRef = useRef(null);

  useEffect(() => {
    async function fetchMessageHistories() {
      const MessageHistories = await axios.get<MessageHistory>(
        '/api/internal/messages/history?limit=' + PER,
      );
      setMessageHistories(MessageHistories.data.message_histories);
      setHistoryTotalCount(MessageHistories.data.history_total_count);
      setIsFetchedHistories(true);
    }
    fetchMessageHistories();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsDisabled(true);

    const messageSendAtFrom = messageSendAtFromRef.current ? messageSendAtFromRef.current.value : ''
    const messageSendAtTo = messageSendAtToRef.current ? messageSendAtToRef.current.value : ''

    axios.get<MessageHistory>(
      '/api/internal/messages/history?search_patient_word=' + patientword
                                   + '&search_message_send_at_from=' + messageSendAtFrom
                                   + '&search_message_send_at_to=' + messageSendAtTo
                                   + '&limit=' + PER,
    ).then(function (response) {
      setMessageHistories(response.data.message_histories);
      setHistoryTotalCount(response.data.history_total_count);
      setMarker(PER);
    }).catch(function (error) {
    }).finally(() => {
      setIsDisabled(false);
    });
  }

  const loadList = () => {
    const messageSendAtFrom = messageSendAtFromRef.current ? messageSendAtFromRef.current.value : ''
    const messageSendAtTo = messageSendAtToRef.current ? messageSendAtToRef.current.value : ''
    // stateに即座に反映されないので一旦変数に入れてそっちを使う
    const newLimit = limit + PER
    setLimit(newLimit)

    axios.get<MessageHistory>(
      '/api/internal/messages/history?search_patient_word=' + patientword
                                   + '&search_message_send_at_from=' + messageSendAtFrom
                                   + '&search_message_send_at_to=' + messageSendAtTo
                                   + '&limit=' + newLimit,
    ).then(function (response) {
      setMessageHistories(response.data.message_histories);
      setHistoryTotalCount(response.data.history_total_count);
    }).catch(function (error) {
    }).finally(() => {
      setMarker(marker + PER);
    });
  }

  return(
    <>
      <h3>メッセージ送信履歴</h3>
      <br/>
      <div className="panel panel-success">
        <div className="panel-heading">検索エリア</div>
        <div className="panel-body">
          <form onSubmit={e => handleSubmit(e)} acceptCharset="UTF-8">
            <input name="utf8" type="hidden" value="✓" />
            <div className="form-group" style={{ display: 'inline-block'}}>
              <label htmlFor="search_patient_word">検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)</label>
              <input
                type="text"
                name="search_patient_word"
                className="form-control col-lg-1"
                placeholder="検索したい内容を入力してください"
                onChange={e => setPatientword(e.currentTarget.value)}
               />
            </div>
            <div className="row">
              <div className="form-group col-sm-10 col-xs-12">
                <label>送信年月日</label>
                <div className="form-inline">
                  <div className="pos_relative pull-left">
                    <input
                      type="text"
                      name="search_message_send_at_from"
                      className="form-control datepicker m5"
                      placeholder="検索日時(from)"
                      ref={messageSendAtFromRef}
                    />
                  </div>
                  <div className="pos_relative pull-left m5">〜</div>
                  <div className="pos_relative pull-left">
                    <input
                      type="text"
                      name="search_message_send_at_to"
                      className="form-control datepicker m5"
                      placeholder="検索日時(to)"
                      ref={messageSendAtToRef}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-2 col-xs-12 text-right">
                <input
                  type="submit"
                  name="button_search"
                  value="検索"
                  className="btn btn-lg btn-primary mt30"
                  disabled={isDisabled}
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      {MessageHistories.length == 0 ? (
        isFetchedHistories && <p className="text-center">送信履歴が存在しません</p>
      ) : (
        <div className="table-responsive message-table-content">
          <table id="notice_table" className="table table-bordered table-hover">
            <thead>
              <tr className="success">
                <th scope="col" className="text-center col-sm-2">送信日時</th>
                <th scope="col" className="text-center col-sm-2">患者名</th>
                <th scope="col" className="text-center col-sm-1">携帯電話番号</th>
                <th scope="col" className="text-center col-sm-1">メッセージ</th>
                <th scope="col" className="text-center col-sm-2">送信したユーザ</th>
                <th scope="col" className="text-center col-sm-1">送信方法</th>
                <th scope="col" className="text-center col-sm-1">チケット消費数</th>
              </tr>
            </thead>
            <tbody>
              {MessageHistories.map((MessageHistory, i) => (
                <tr key={i}>
                  <td className="va_middle text-center">{MessageHistory.converted_message_send_at}</td>
                  <td className="va_middle text-center">{MessageHistory.m_patient_name}</td>
                  <td className="va_middle text-center">{MessageHistory.phone_number}</td>
                  <td className="va_middle text-center send-message">
                  <button type="button" className="btn btn-primary" data-toggle="modal" data-target={`#messageModal${i}`}>
                    <span className="glyphicon glyphicon-plus-sign message-modal-icon"></span>表示
                  </button>

                  <div className="modal fade" data-backdrop="static" id={`messageModal${i}`}>
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header message-modal-header">
                          <button type="button" className="close close-btn" data-dismiss="modal"><span>×</span></button>
                        </div>
                        <div className="modal-body message-content">
                        {MessageHistory.message}
                        </div>
                      </div>
                    </div>
                  </div>
                  </td>
                  <td className="va_middle text-center">{MessageHistory.m_user_name}</td>
                  <td className="va_middle text-center">{ MessageHistory.send_kbn == SEND_KBN.SMS ? "SMS" : "LINE" }</td>
                  <td className="va_middle text-center">
                    { MessageHistory.send_kbn == SEND_KBN.SMS ? MessageHistory.consumed_ticket_count : "-" }
                  </td>
                </tr>
              )).slice(0, marker)}
            </tbody>
          </table>
          {
            hitoryTotalCount > marker
              ? <div className="text-center"><button className="btn btn-default more-btn" onClick={loadList}>もっと表示 ▼</button></div>
              : ''
          }
        </div>
      )}
    </>
  );
}

export default History
